import {getMethod, postMethod} from '~/api'

async function get(request) {
    return await getMethod('/proxy/recentViews', request)
}

async function post(request) {
    return await postMethod('/proxy/recentViews', request)
}

export {get, post}
